export default "__VITE_ASSET__SQJ8r3OL__"